const header = document.querySelector('.site-header')

const state = {
  stuck: true,
}

const fn = {
  init: () => {
    fn.handleScroll()
    fn.bindEvents()
  },

  bindEvents: () => {
    window.addEventListener('scroll', fn.handleScroll)
  },

  handleScroll: () => {
    state.stuck = window.scrollY > 1
    header.classList.toggle('is-stuck', state.stuck)
  },
}

export default {
  can: () => header,
  run: fn.init,
}
